<template>
  <div class="about">
    <h1>Pagina no encontrada</h1>
  </div>
</template>
